var map = {
	"./auoas.jpg": 90,
	"./buckingham.jpg": 91,
	"./bundesministerium.jpg": 92,
	"./ebs.jpg": 93,
	"./esf.jpg": 94,
	"./eu_commission.jpg": 95,
	"./eu_institute.jpg": 96,
	"./exist.jpg": 97,
	"./foggia.jpg": 98,
	"./gesis.jpg": 99,
	"./glu.jpg": 100,
	"./heidelberg.jpg": 101,
	"./hertie.jpg": 102,
	"./htw_berlin.jpg": 103,
	"./itmo.png": 104,
	"./jacobs.jpg": 105,
	"./jgu.jpg": 106,
	"./kit.jpg": 107,
	"./land_der_ideen.jpg": 108,
	"./luiss.jpg": 109,
	"./mhmk.jpg": 110,
	"./open_education.jpg": 111,
	"./osnabrueck.jpg": 112,
	"./padova.jpg": 113,
	"./passau.jpg": 114,
	"./pavia.jpg": 115,
	"./pfur.jpg": 116,
	"./reutlingen.jpg": 117,
	"./rwth.jpg": 118,
	"./salford.jpg": 119,
	"./stifterverband.jpg": 120,
	"./tpu.jpg": 121,
	"./tsu.jpg": 122,
	"./tusur.jpg": 123,
	"./udima.jpg": 124,
	"./unep.jpg": 125,
	"./usi.jpg": 126,
	"./whu.jpg": 127,
	"./wwf.jpg": 128
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89;